import { render } from "./GreetingCircle.vue?vue&type=template&id=f4cc284e&scoped=true&ts=true"
import script from "./GreetingCircle.vue?vue&type=script&lang=ts"
export * from "./GreetingCircle.vue?vue&type=script&lang=ts"

import "./GreetingCircle.vue?vue&type=style&index=0&id=f4cc284e&scoped=true&lang=scss"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4cc284e"]])

export default __exports__